import { CreditCardResponse, WithCreditCards } from './creditCard'
import { Locales } from './locale'
import { POSCountry } from './pos'
import { VirtualPaymentAutomation } from './virtualPaymentAutomation'

// eslint-disable-next-line no-restricted-syntax
export enum CompanyInvoiceStatus {
	Draft = 'draft',
	ConfirmationInProgress = 'confirmation_in_progress',
	TermsOfServiceValidationPending = 'validation_pending',
	Blank = 'blank',
	Active = 'active',
}

export interface InvoicePerson {
	id?: number
	first_name: string
	last_name: string
	email: string
	phone_number: string
	is_same_as_main_contact: boolean
}

export interface InvoiceProfile extends WithCreditCards<CreditCardResponse[] | null> {
	id: number

	contract_start_date?: string | null

	display_name: string | null
	description: string | null

	status: CompanyInvoiceStatus

	industry: string | null
	legal_entity_names: string[] | null

	tax_number: string | null
	trade_register_number: string | null
	corporate_id: string | null

	building: string | null
	room: string | null
	floor: string | null

	streets: string[] | null
	number: string | null
	district: string | null
	postal_code: string | null
	city: string | null

	country: POSCountry | null
	country_pos_id: number | null
	language: Locales | null

	authorized_person_user: InvoicePerson | null
	default_email: string | null

	billing_contact_person_first_name: string | null
	billing_contact_person_last_name: string | null
	billing_contact_person_email: string | null
	billing_contact_phone_number: string | null

	state: string | null

	virtual_payment_automations: VirtualPaymentAutomation[] | null
}
